import type { LotEvent } from '../types/lot'

type EventWithLotIds = LotEvent & { lotIds?: unknown }

const eventLotIds = (event: EventWithLotIds): string[] => [
  ...event.sourceLotIds,
  ...event.targetLotIds,
  ...(Array.isArray(event.lotIds) ? event.lotIds.filter((id): id is string => typeof id === 'string') : [])
]

/**
 * Findings #176: Historial loads the whole lineage, so a lot stocked with
 * "Sembrar en varias unidades" also listed every sibling unit's moves. Keep
 * only the events of the chosen lot and of the lots it came from (the arrival,
 * the split / merge that made it), oldest first.
 */
export const scopeHistoryToLot = <T extends LotEvent>(events: readonly T[], lotId: string): T[] => {
  const relevant = new Set([lotId])
  // Walk back through splits / merges: a lot that produced a relevant lot is an ancestor.
  let grew = true
  while (grew) {
    grew = false
    for (const event of events) {
      if (!event.targetLotIds.some((id) => relevant.has(id))) continue
      for (const source of event.sourceLotIds) {
        if (!relevant.has(source)) {
          relevant.add(source)
          grew = true
        }
      }
    }
  }

  return events
    .filter((event) => eventLotIds(event).some((id) => relevant.has(id)))
    .slice()
    .sort((left, right) => left.recordedAt.localeCompare(right.recordedAt))
}
